import AclName from '../AclName';

export default [
  AclName.CanViewKsefSettings,
  AclName.CanEditKsefSettings,
  AclName.CanViewKsefPurchaseInvoicesList,
];
